import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./TopBar.css";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import Avatar from "react-avatar";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import { useDeleteDummyStudent } from "../../../../hooks/school/student/useDeleteDummyStudent";
import { useSchlStudentNotification } from "../../../context/StudentNotificationContext/SchlStudentNotificationContext";
import { useGetUnreadCount } from "../../../../hooks/organization/notification/useGetUnreadCount";
import NavbarLogin from "../../../WebUi/Components/HomeV2/NavbarLogin";
// import { languageList } from "../../../i18n/languageList";
// import { useTranslation } from "react-i18next";
// import { changeLanguage } from "../../../i18n/helpers/changeLanguage";

export const StudentTopbar = ({ userType }) => {
  const { student, studentLogout } = useAuthStudent();
  const navigate = useNavigate(); // Initialize the navigate function
  const { currentUser, logout } = useTenantAuth();
  const { deleteDummyStudent } = useDeleteDummyStudent();
  // const { i18n } = useTranslation();
  // const [notificationCount, setNotificationCount] = React.useState(3);
  const { unreadCount, setUnreadCount } = useSchlStudentNotification();
  const { getUnreadCount } = useGetUnreadCount();
  // const currentLang =
  //   languageList.find((l) => l.code === i18n.language) || languageList[0];

  const handleLogout = async () => {
    await studentLogout(); // Ensure logout is completed before navigating
    navigate("/login");
  };

  /**
   * Handle logout for school-students.
   * If the user is a dummy student, destroy the dummy account first.
   */
  const handleDummyLogout = async () => {
    if (currentUser?.is_dummy_student) {
      try {
        await deleteDummyStudent();
      } catch {
        // Continue with logout even if destroy fails
      }
    }
    await logout();
  };

  useEffect(() => {
    const fetchInitialCount = async () => {
      const count = await getUnreadCount();
      if (count !== null && count !== undefined) {
        setUnreadCount(count);
      }
    };

    fetchInitialCount();
  }, []);

  return (
    <div
      className="container-fluid"
      style={{
        backgroundColor: "#ffffff",
        paddingLeft: "40px",
        paddingRight: "40px",
        paddingTop: "10px",
        paddingBottom: "10px",
      }}
    >
      <div className="row">
        <div className="col-md-4 col-5 d-flex align-items-center">
          <Link to="/" className="d-flex align-items-center">
            <img
              className="YQTopBarLogo d-md-block d-none"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/home/topbar/YQLogo.png"
              alt=""
            />
            <img
              className="YQTopBarMobLogo d-md-none d-block"
              src="http://d2lvj32mp5x83n.cloudfront.net/static/YQ+1+(1).png"
              alt=""
            />
          </Link>
        </div>
        <div className="col-md-8 col-7 d-flex align-items-center justify-content-end">
          {/* start language selector */}
          <div className="dropdown lang-switcher me-2">
            {/* <button
              className="lang-btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {currentLang.label}
            </button> */}

            {/* <ul className="dropdown-menu dropdown-menu-end lang-menu">
              {languageList.map((lang) => (
                <li key={lang.code}>
                  <div
                    className={`lang-option ${
                      i18n.language === lang.code ? "active" : ""
                    }`}
                    onClick={() => changeLanguage(lang)}
                  >
                    <span>{lang.label}</span>
                    {i18n.language === lang.code && <span>✓</span>}
                  </div>
                </li>
              ))}
            </ul> */}
          </div>
          {/* end language selector */}

          {userType === "school-student" && (
            <div
              className="notification-bell me-3 position-relative"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/student/admin/notifications")}
            >
              <i className="fa-solid fa-bell" style={{ fontSize: "20px" }}></i>
              {unreadCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-5px",
                    backgroundColor: "#0d6efd",
                    color: "white",
                    borderRadius: "50%",
                    padding: "2px 6px",
                    fontSize: "8px",
                  }}
                >
                  {unreadCount}
                </span>
              )}
            </div>
          )}

          <div className="btn-group align-self-center ms-3">
            {userType === "school-student" ? (
              <div
                type="button"
                className="dropdown-toggle studenttopbarName mb-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="d-md-inline d-none">{currentUser?.name}</span>{" "}
                <Avatar
                  name={currentUser?.name}
                  color="#008EF4"
                  round="20px"
                  size="35"
                />
              </div>
            ) : (
              <NavbarLogin />
            )}

            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <Link className="dropdown-item" to={"/student/admin/profile"}>
                  Profile
                </Link>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                {userType === "school-student" ? (
                  <Link className="dropdown-item" onClick={handleDummyLogout}>
                    Logout
                  </Link>
                ) : (
                  <Link className="dropdown-item" onClick={handleLogout}>
                    Logout
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
